import { Spinner } from "@nextui-org/react";
import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import PageStaticMetaTags from "@/components/common/PageStaticMetaTags";
import { FEATURE_FLAGS } from "@/constants";
import { useFeatureFlag } from "@/hooks";
import AnonymousMarketing from "@/pages/AnonymousMarketing/AnonymousMarketing";
import useAuth from "@/services/useAuth";

import { Voice } from "../Voice";

export const VoiceCreate = () => {
  const { hasFeatureFlag: hasVoice, isLoading: isVoiceLoading } = useFeatureFlag(FEATURE_FLAGS.TTS);
  const { isAuthenticated } = useAuth();

  let pageContent: ReactNode;
  if (isVoiceLoading) {
    pageContent = <Spinner />;
  } else if (!hasVoice) {
    pageContent = <Navigate to="/" />;
  } else if (isAuthenticated) {
    pageContent = <Voice />;
  } else {
    pageContent = <AnonymousMarketing datakey="voice" />;
  }

  return (
    <>
      <PageStaticMetaTags pageId="createVoice" data-testid="VoiceCreate-PageStaticMetaTags" />
      {pageContent}
    </>
  );
};

export default VoiceCreate;
